import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-bold" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxCardIssueEventWorkRejected from "src/components/card/issue-event/SfxCardIssueEventWorkRejected.vue"
import SfxDataPoint from "src/components/data-point/SfxDataPoint.vue"
import SfxImageGallerySmall from "src/components/images/SfxImageGallerySmall.vue"
import { getImageAttachmentsFromAttachmentIds, getImages } from "src/util/functions/attachments"
import { getCorrectiveWorkOnItemData } from "src/util/functions/performedWork"
import { ImageGalleryItem } from "src/util/types/components/sfxImageGallery"
import { IssueCorrectiveWorkRejectedEventCard } from "src/util/types/dataModels/issue"
import { CorrectiveWorkOnItem } from "src/util/types/dataModels/performedWork"
import { onMounted, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogRejectedCorrectiveWork',
  props: {
  issueEventCard: {
    type: Object as PropType<IssueCorrectiveWorkRejectedEventCard>,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogCancel } = useDialogPluginComponent()

const title = t("sfxDialogRejectedCorrectiveWork.title")
const labelWorkStatement = t("sfxDialogRejectedCorrectiveWork.label_corrective_work_statement")
const btnGotIt = t("sfxButtons.btn_got_it_period")

const correctiveWork = ref<CorrectiveWorkOnItem | undefined>()
const images = ref<ImageGalleryItem[] | undefined>([])

//endregion

//region Lifecycle

onMounted(async () => {
  if (props.issueEventCard) {
    correctiveWork.value = await getCorrectiveWorkOnItemData(props.issueEventCard.entityId)
    await getImagesFromAttachments()
  }
})

//endregion

//region Functions

async function getImagesFromAttachments() {
  if (correctiveWork.value?.attachments && correctiveWork.value.attachments.length > 0) {
    try {
      const imgAttachments = await getImageAttachmentsFromAttachmentIds(
        correctiveWork.value.attachments
      )
      images.value = await getImages(
        imgAttachments,
        "corrective_work_item",
        correctiveWork.value.id
      )
    } catch {
      // If it fails, then there are no images to show, so nothing really breaks, and we get the sentry error
    }
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-rejected-corrective-work"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          (props.issueEventCard)
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 0,
                class: "q-pb-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(SfxCardIssueEventWorkRejected, {
                    "issue-event-card": props.issueEventCard,
                    "show-hand": false,
                    manager: ""
                  }, null, 8, ["issue-event-card"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_section, { class: "q-pb-lg" }, {
            default: _withCtx(() => [
              _createVNode(SfxDataPoint, {
                label: _unref(labelWorkStatement),
                manager: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(correctiveWork.value?.title), 1),
                  _createElementVNode("div", null, _toDisplayString(correctiveWork.value?.description), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pb-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxImageGallerySmall, {
                "image-src": images.value,
                "entity-id": props.issueEventCard.entityId,
                "entity-type": "corrective_work_item",
                "disable-edit-image": ""
              }, null, 8, ["image-src", "entity-id"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtn, {
                class: "full-width",
                label: _unref(btnGotIt),
                onClick: _unref(onDialogCancel)
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})